import OTPService from './OTPService';
import { generateGameLaunchUrl, showError } from '../../shares/lib/otpUtils';
import validateGameOtpConfig from '../../shares/lib/validateGameOtpConfig';
import { LogiSDKConfig } from '../../shares/model/config';

const playForRealGame = async (swipeSDKConfig: LogiSDKConfig) => {
  try {
    const isValid = validateGameOtpConfig(swipeSDKConfig.otpConfig);
    if (!isValid) {
      return null;
    }

    const otpService = new OTPService(swipeSDKConfig.otpConfig);
    const responseOTP = await otpService.getOTP();
    if (!responseOTP) {
      throw new Error('Game OTP Not Found');
    }

    return generateGameLaunchUrl(
      swipeSDKConfig.swipeGames?.gameLaunchConfig as never,
      responseOTP,
    );
  } catch (error) {
    showError('Error in playForRealGame:', error);
    return null;
  }
};

export default playForRealGame;
